import { type PreviewStaticModule } from '@/lib/builder/types'

import AnnouncementPreview from './AnnouncementPreview.vue'

export const AnnouncementsHeader: PreviewStaticModule = {
  preview: AnnouncementPreview,
}
